var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvas",staticStyle:{"width":"100%"},attrs:{"height":"200"}})}
var staticRenderFns = []

export { render, staticRenderFns }